"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created on Wed Nov 07 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * PromoSettingsConverter.
 *
 * @author ZSt
 */


var PromoSettingsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromoSettingsConverter, _DataObjectConverter_);

  function PromoSettingsConverter() {
    _classCallCheck(this, PromoSettingsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoSettingsConverter).apply(this, arguments));
  }

  return PromoSettingsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromoSettingsConverter = PromoSettingsConverter;